import { setToken,removeToken } from '@/utils/auth'
import {getUserInfo,getSystemMsgRedPoint,getManufactUrerInfo} from '@/api/user'
import router from '@/router'

const state = {
  token:'',
  userInfo:null,
  isLogin:false,
  messageNum:0,
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  setIsLogin: (state, isLogin) => {
    state.isLogin = isLogin
  },
  setMessageNum: (state, messageNum) => {
    state.messageNum = messageNum
  }
}

const actions = {
  // 登录成功后
  loginSuccess({commit},data){
    localStorage.setItem('token', data.token)
    localStorage.setItem('userInfo', JSON.stringify(data.user))
    setToken(data.token)
    commit('SET_TOKEN', data.token)
    commit('SET_USERINFO', data.user)
    commit('setIsLogin', true)
  },

  // 获取用户信息
  getUserInfo({commit}){
    return new Promise((resolve, reject) => {
      getUserInfo().then(res => {
        // localStorage.setItem('token', res.data.token)
        localStorage.setItem('userInfo', JSON.stringify(res.data))
        // setToken(data.token)
        // commit('SET_TOKEN', res.data.token)
        commit('SET_USERINFO', res.data)
        commit('setIsLogin', true)
        resolve(res)
      }).catch(err => {
        resolve(err)
      })
    })
  },
  getMessagePoint({commit}){
    // 获取消息红点
    getSystemMsgRedPoint().then(res => {
      if(res.code == 0){
        commit('setMessageNum', res.data.isReadRed)
      }
    })
  },

  // 读取本地的用户信息
  readLocalUserInfo({commit}){
    var userInfo = JSON.parse(localStorage.getItem('userInfo'))
    var token = localStorage.getItem('token')
    setToken(token)
    commit('SET_TOKEN', token)
    commit('SET_USERINFO', userInfo)
    commit('setIsLogin', true)
  },

  // 退出登录
  loginOut({commit}){
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('expire_time')
    localStorage.removeItem('userType')
    commit('SET_TOKEN', '')
    commit('SET_USERINFO', {})
    commit('setIsLogin', false)
    removeToken()
    router.push({path:'/'})
  },


  // 厂家的
  mfGetUserInfo({commit}){
    return new Promise((resolve, reject) => {
      getManufactUrerInfo().then(res => {
        localStorage.setItem('userInfo', JSON.stringify(res.data))
        commit('SET_USERINFO', res.data)
        commit('setIsLogin', true)
        resolve(res)
      }).catch(err => {
        resolve(err)
      })
    })
  }
}

const getters = {
  
}

export default {
  state,
  mutations,
  actions,
  getters
}